export const keys = {
    all: ["alarm-schedule-admin"],

    // referenceData: (groupID: number, 
    //     organizationID: number

    // ) => [
    //     ...keys.all,
    //     "referencedata", {
    //         groupID,
    //         organizationID         
    //         }
    // ],
    // getAlarmScheme: (
    //     organizationID: number | undefined,
    //     groupID: number,
    //     alarmSchemeID: number | undefined,
        
    // ) => [
    //     ...keys.all,
    //     "getAlarmScheme", {
    //         organizationID,
    //         groupID,
    //         alarmSchemeID,
    //     }
    // ],
    alarmSchedules: (
        organizationID: number,
        groupID: number,
        includeLinkedAlarmSchemes: boolean
        ) => [
            ...keys.all,
            "alarmschedules", {
                organizationID,
                groupID,
                includeLinkedAlarmSchemes
            }
        ],
    alarmSchedule: (
        organizationID: number,
        groupID: number,
        alarmScheduleID: number,
        includeLinkedAlarmSchemes: boolean
        ) => [
            ...keys.all,
            "alarmschedule", {
                organizationID,
                groupID,
                alarmScheduleID,
                includeLinkedAlarmSchemes
            }
        ],
    
};

